<!-- 车辆列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <carAction ref="carAction" v-if="showStatus" @drawerCancel="drawerCancel" @toDetail="toDetail"
                :actionData="actionData"></carAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="formList.carList.length > 0" :flagList="['searchVmInspectiontime']"
                    :searchList="formList.carList" :getRequestData="getRequestData" @searchData="searchData"
                    @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-date-picker size="mini" v-model="searchVmInspectiontime" type="daterange" unlink-panels
                            :picker-options="searchDatePack" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="timestamp" align="right">
                        </el-date-picker>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
                border style="width: 100%" highlight-current-row>
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="ormName" label="归属组织" show-overflow-tooltip min-width="150">
                </el-table-column>
                <el-table-column align="center" prop="vmLicensecode" label="车牌号" show-overflow-tooltip min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="vmVinno" label="车架号" show-overflow-tooltip min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="vmBrand" label="品牌" show-overflow-tooltip min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="vmColor" label="颜色" show-overflow-tooltip min-width="120">
                </el-table-column>
                <el-table-column align="center" prop="vmProducer" label="生产商" show-overflow-tooltip min-width="150">
                </el-table-column>
                <el-table-column align="center" prop="vmSupplier" label="供货商" show-overflow-tooltip min-width="150">
                </el-table-column>
                <el-table-column align="center" prop="vmBuytime" label="购买时间" show-overflow-tooltip min-width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.vmBuytime">
                            {{ $common.getLocalTime(scope.row.vmBuytime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="vmInspectiontime" label="年检时间" show-overflow-tooltip min-width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.vmInspectiontime">
                            {{ $common.getLocalTime(scope.row.vmInspectiontime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="vmState" label="状态" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.vmState == 1">启用</el-tag>
                        <el-tag size="mini" v-if="scope.row.vmState == 0">停用</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './otherData.js'
import carAction from "@/components/carAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {carAction},
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            showStatus: false,
            actionData: {},
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchDatePack: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近半年年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                ]
            },



            buttonList: [],
            getRequestData: {
                ormId: '',
                vmLicensecode: '',
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                page: 1,
                rows: 30,
            },
            searchVmInspectiontime: [],
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: []
            },
            selectedDataIndex: 0,
            formList: formList

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        openSearch() { },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        type: ''
                    }
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: '请先选择您要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: [],
                        oldData: dataInfo,
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        type: ''
                    }
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3:
                    this.changeStatus()
                    break;
            }
        },
        async changeStatus() {
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            let params = {
                ids: [dataInfo.vmId]
            }
            let responseData = await this.$http.stopVehicle(params)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: '暂无数据',
                        type: 'error'
                    });
                    return false
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.vmId]
                }
                let responseData = await this.$http.delCarList(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });

        },

        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            this.getRequestData.start = ''
            this.getRequestData.end = ''

            if (this.searchVmInspectiontime != null && this.searchVmInspectiontime.length >= 2) {
                this.getRequestData.start = this.searchVmInspectiontime[0]
                this.getRequestData.end = this.searchVmInspectiontime[1]
            }
            let responseData = await this.$http.getCarList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped></style>